module.exports = "/packs/media/images/oldercouple_dog-be827b3dbd23233ac33225c32a7a70e1.jpg";